
  export const BRANCHES_RECEIVED = "BRANCHES_RECEIVED";
  export const SET_BRANCH = "SET_BRANCH";
  export const CREATE_BRANCH = "CREATE_BRANCH";
  export const SET_PROPERTY_BRANCH = "SET_PROPERTY_BRANCH";
  export const SET_BRANCH_FORM = "SET_BRANCH_FORM";
  export const SET_EDIT_BRANCH_MODE = "SET_EDIT_BRANCH_MODE";
  